module.exports = __webpack_public_path__ + "static/img/rbg-cool.c2729458.png";